module.exports = __webpack_public_path__ + "static/media/superai_symbol_white_lg.ba60edbf.png";